/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/jsx-curly-brace-presence */

import React, { useState } from "react";
import { useSelector } from "react-redux";
import LinkSpanTag from "../LinkSpanTag";
import ShowRightDropDownMenu from "./ShowRightDropdownMenu";

function RightBlogs({ showBlogMenu, setShowBlogMenu, showCategoryMenu, setShowCategoryMenu, closeLeftRightMenu }) {
  const [categoryId, setCategoryId] = useState("");
  const blogData = useSelector((state) => state?.home?.blog_category_subcategory);

  const onClickCategory = (id) => {
    const idd = document.getElementById(`${id}`);
    setCategoryId(`${idd?.id}`);
  };

  return (
    // eslint-disable-next-line react/react-in-jsx-scope
    <li className="menu-item">
      <ShowRightDropDownMenu
        closeLeftRightMenu={closeLeftRightMenu}
        showMenu={showBlogMenu}
        setShowMenu={setShowBlogMenu}
        href={!showBlogMenu && "/blog"}
        name="Blog"
      />

      <div className={`menu-sub menu-sub-accordion ${showBlogMenu && "show"}`}>
        {blogData?.map((item) => {
          return (
            <div aria-hidden="true" onClick={() => onClickCategory(item?.id)} id={item?.id} key={item?.id} className="menu-item">
              <ShowRightDropDownMenu
                id={`${item.id}`}
                // eslint-disable-next-line eqeqeq
                showMenu={showCategoryMenu && item?.id == categoryId}
                href={!showCategoryMenu && `/blog/${item?.slug}`}
                setShowMenu={setShowCategoryMenu}
                name={`${item.type}`}
                closeLeftRightMenu={closeLeftRightMenu}
              />
              {item?.sub_type?.map((subcategory) => {
                return (
                  <div
                    key={subcategory.id}
                    id={`${item.id}`}
                    // eslint-disable-next-line eqeqeq
                    className={`menu-sub menu-sub-accordion ${showCategoryMenu && item.id == categoryId ? "show" : ""}`}
                  >
                    <div aria-hidden onClick={() => closeLeftRightMenu()} className="menu-item">
                      {/* eslint-disable-next-line react/react-in-jsx-scope */}
                      <LinkSpanTag
                        href={`/blog/${item.slug}/${subcategory?.slug}`}
                        className="menu-link"
                        spanUp="bullet bullet-dot"
                        iconSpanClass="menu-bullet"
                        name={`${subcategory?.name}`}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </li>
  );
}
export default RightBlogs;
